export const certificateStatusOptions = [
  { key: "pending", label: "Pendente" },
  { key: "approved", label: "Aprovado" },
  { key: "rejected", label: "Reprovado" },
];